import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getUserAssignedCourses, type AssignedCourse } from '../lib/api/users';

export type CourseAccessResult = {
  hasAccess: boolean;
  loading: boolean;
  error: string | null;
};

export const useCoursePermission = (courseId: number): CourseAccessResult => {
  const { user } = useAuth();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkPermission = async () => {
      if (!user) {
        setHasAccess(false);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await getUserAssignedCourses(user.id);
        const assignedCourses: AssignedCourse[] = response.data || [];
        
        const targetCourse = assignedCourses.find((c) => c.course_id === courseId);
        
        if (targetCourse && targetCourse.stages) {
          const hasLessonPermission = targetCourse.stages.some(
            (stage) => stage.lessons && stage.lessons.length > 0
          );
          setHasAccess(hasLessonPermission);
        } else {
          setHasAccess(false);
        }
        setError(null);
      } catch (err) {
        console.error('Failed to check course permission:', err);
        setError('Failed to check permission');
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, [user, courseId]);

  return { hasAccess, loading, error };
};

export const VIBE_CODING_COURSE_ID = 5;
export const AI_VEX_COURSE_ID = 6;
